// <head> metadata for HomePage (https://www.dbos.dev/).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'DBOS | Durable Workflow Orchestration',
    },
    {
      name: 'description',
      content:
        'DBOS is an open source durable execution and workflow orchestration system that radically simplifies the development and operation of reliable, observable workflows.',
    },
    {
      property: 'og:title',
      content: 'DBOS | Durable Workflow Orchestration',
    },
    {
      property: 'og:description',
      content:
        'DBOS is an open source durable execution and workflow orchestration system that radically simplifies the development and operation of reliable, observable workflows.',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/675883fe7419fd4747ef5ae3_DBOS-Website-OG.jpg',
    },
    {
      name: 'twitter:title',
      content: 'DBOS | Durable Workflow Orchestration',
    },
    {
      name: 'twitter:description',
      content:
        'DBOS is an open source durable execution and workflow orchestration system that radically simplifies the development and operation of reliable, observable workflows.',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/675883fe7419fd4747ef5ae3_DBOS-Website-OG.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
